export default __webpack_public_path__ + "static/media/bcessentials.d000d973.PNG";